import { ComponentPropsWithoutRef } from 'react';

import { cn } from '@app/shared/utils/common';

type MainSectionProps = ComponentPropsWithoutRef<'main'>;

export function MainSection({ className, ...rest }: MainSectionProps) {
  return <main className={cn('flex-1 overflow-hidden pb-[20px]', className)} {...rest} />;
}
